<template>
  <div>
    <h1>NotFound</h1>
    <button v-on:click="goBack">GO BACK</button>
  </div>
</template>

<script type="text/babel">

export default {
    name: 'Error',
    methods: {
      goBack() {
        this.$router.go(-1);
      }
    },
    mounted(){
      setTimeout(()=>{
        this.goBack();
      },3000);
    }
};

</script>
